import { CosmosChainIds } from '@shared/types'
import { ENDPOINTS } from '@shared/utils/constant'
import {
  Network,
  isDevnet,
  isMainnet,
  isTestnet,
  getCw20AdapterContractForNetwork
} from '@injectivelabs/networks'

export const NETWORK: Network =
  (import.meta.env.VITE_NETWORK as Network) || Network.Devnet
export const IS_DEVNET = isDevnet(NETWORK)
export const IS_TESTNET = isTestnet(NETWORK)
export const IS_MAINNET = isMainnet(NETWORK)

export const IS_LAYERZERO_AVAILABLE = IS_MAINNET

export const IS_PRODUCTION: boolean = process.env.NODE_ENV === 'production'

export const CW20_ADAPTER_CONTRACT = getCw20AdapterContractForNetwork(
  NETWORK
) as string
/** todo */
export const CW20_WRAPPER_CONTRACT =
  'inj182hvp064stesu55clqnzhm68vj84qgt0jxf0ln'
export const SOL_ALCHEMY_KEY = import.meta.env.VITE_SOL_ALCHEMY_KEY
export const SOL_DEVNET_ALCHEMY_KEY = import.meta.env
  .VITE_SOL_DEVNET_ALCHEMY_KEY
export const DRPC_KEY = import.meta.env.VITE_DRPC_KEY
// In dev, talk to the BFF on whatever host the page was opened from so LAN
// and Tailscale clients work without baking an IP into the bundle.
export const BFF_ENDPOINT =
  import.meta.env.VITE_BFF_ENDPOINT ||
  (import.meta.env.DEV
    ? `${window.location.protocol}//${window.location.hostname}:4000`
    : ENDPOINTS.bffApi)

export const PEGGY_GRAPH_URL = (): string => {
  if (IS_TESTNET) {
    // Note: this endpoint doesn't work. ticket for chain team :https://injective-labs.atlassian.net/browse/ECO-159
    return 'https://api.studio.thegraph.com/query/73355/injective-peggo-sepolia/version/latest'
  }

  // return 'https://api.studio.thegraph.com/query/82145/injective-peggy/v1.0.0' // Deprecated

  return 'https://gateway.thegraph.com/api/subgraphs/id/4vxQ8VNvPxJmgVzEvoEv28RBv81URZFavHY7u2R28zJ8'
}

export const ONRAMPER_SIGNING_KEY =
  import.meta.env.VITE_ONRAMPER_SIGNING_KEY || ''
export const IS_ONRAMPER_DEV_MODE =
  import.meta.env.VITE_IS_ONRAMPER_DEV_MODE === 'true'
export const ONRAMPER_API_KEY = IS_ONRAMPER_DEV_MODE
  ? import.meta.env.VITE_ONRAMPER_API_KEY_DEV
  : import.meta.env.VITE_ONRAMPER_API_KEY_PROD
export const MIXPANEL_KEY = import.meta.env.VITE_MIXPANEL_KEY || ''
export const SKIP_BASE_URL = import.meta.env.VITE_SKIP_BASE_URL || ''

export const INJECTIVE_CHAIN_ID = IS_TESTNET
  ? CosmosChainIds.InjectiveTestnet
  : CosmosChainIds.Injective

export const COSMOS_HUB_CHAIN_ID = IS_TESTNET
  ? CosmosChainIds.CosmosHubTestnet
  : CosmosChainIds.CosmosHub

export const THE_GRAPH_API_KEY = import.meta.env.VITE_THEGRAPH_API_KEY || ''
